import '../Pulsar.css';
import Video from '../VideoYouTube';
import img0 from '../todos_recursos/el-equipo-a-01.jpg';
import img1 from '../todos_recursos/vaqueros.png';
import img2 from '../todos_recursos/anibalDisfrazado.png';
import img3 from '../todos_recursos/furgonetaAteam.jpg';

function ElequipoA () {
    
    return(
<>
        
        

        <h1>El equipo A</h1>
        <h2>1985. Sábado por la tarde. </h2>
        <p>
            Afortunadamente mis padres no me habían arrastrado hasta El Corte Inglés o el supermercado, como sucedía otros muchos 
            sábados. Intentaba ahuyentar el aburrimiento frente al televisor. Después de ver el capítulo semanal de <i>David el Gnomo</i> (me encantaba) en la 
            sobremesa y el principio de la tradicional película del Oeste que emitían en TVE y a la que mi padre era un gran asiduo 
            (aunque siempre terminaba roncando en algún intervalo de anuncios y prolongaba su siesta algo más, perdiéndose parte del argumento del filme), había estado jugando un buen 
            rato en mi habitación, ideando las situaciones más imaginativas y rocambolescas, pero todo llega a su fin y necesitaba otros estímulos.
        </p>
        <img src={img1} alt='Imagen de televisor con película del oeste' style={{ display: 'block',margin: '30px auto', width: '70%'}}/>
        <p>
            La programación infantil y familiar solo ocupaba ciertas franjas y las niñas avispadas (y niños, claro está) las conocíamos bien. <i>Las aventuras de los osos gummi</i> habían 
            absorbido toda mi atención durante un rato y, al ver, apenada, los créditos de cierre, no sabía si exprimirme el cerebro tratando de encontrar una nueva idea en la que 
            centrar mis juegos, buscar a mis padres para darles la tabarra o asomarme a la cocina para husmear en los armarios en busca de algo que calmara mi inquietud. Entonces, 
            en ese preciso momento, la pantalla me regaló nuevas imágenes, esta vez muy reales porque el canal no ofrecía más dibujos animados, que me mantuvieron pegadas a la alfombra,
             donde solía acomodarme para estar más cerca de la televisión. 
        </p>
        <img className="imagenIzq" src={img2} alt='Anibal de la serie el equipo A' style={{width: '50%'}}/>
        <p>
            En la escena podía verse a un hombre que vestía un aparatoso y espectacular disfraz de monstruo, con la pieza que debía cubrir la cabeza en una mano y un teléfono en la otra. 
            Al parecer, alguien lo avisaba y le indicaba que pasaría a recogerlo. Aquella breve conversación, no sé muy bien por qué, me fascinó. 
            Y más lo hizo la cabecera de la serie que me sorprendió a continuación:
        </p>
            
        <p>
            “En 1972, cuatro de los mejores hombres del Ejército Americano, que formaban un comando, fueron encarcelados por un delito que no habían cometido. No tardaron en escaparse de 
            la prisión en que se encontraban recluidos. Hoy, buscados todavía por el gobierno, sobreviven como soldados de fortuna. Si tiene usted algún problema y se los encuentra, quizá 
            pueda contratarlos. EL EQUIPO A”. Discurso pronunciado con tambores militares de fondo hasta que entraba en juego esa pegadiza melodía que todos podríamos, sin duda, cantar 
            a coro. Tan tan tan, tan tan tan, tararararan, tarararaaaaa… Y sin que faltara, incluso, la guitarra eléctrica para dar un poco de caña a lo que se convertiría en el himno de toda 
            una generación. 
        </p>
        
                <Video id="ExnAw-WqIH8" titulo="Cabecera El Equipo A" />

        <h2>Héroes de los 80.</h2>
        
        <p>
            El coronel <stronc>John Hannibal Smith</stronc>, el cabecilla; el teniente <strong>Templeton Arthur Peck</strong>, conocido en España como Fénix; el capitán <strong>H. M. Murdock</strong> y el sargento <strong>M. A. Baracus</strong> eran 
            para los espectadores unos auténticos héroes, unos justicieros que, a su vez, huían de la justicia militar por una falsa acusación. Eran inocentes de los cargos que 
            se les habían imputado y, como no confiaban en que la verdad prevaleciera, habían escapado y se dedicaban a ayudar a otras personas que pudieran contratar sus servicios 
            -a veces por un ridículo precio-. Y salvaban a otros de una situación insostenible con lo poco que tenían a su alcance, contando con la astucia y capacidad de planificación 
            de Hannibal, las disparatadas pero efectivas ideas de Murdock, el don de gentes y de camuflaje de Fénix y la inventiva de M. A. (y su mala leche también). Y nunca se hacía 
            nadie el menor rasguño, no había bajas, los finales eran siempre felices. Hasta que los cuatro amigos fueron capturados y comenzó una nueva etapa en la serie.
        </p>

            <img src={img0} alt='Imagen de los protagonistas de la seria El equipo A' className='imagenCentrada' style={{width: '55%'}}/>

        <p>
            Pero eso ya no lo veríamos los sábados por la tarde, seríamos testigos de ello después de una buena comilona durante las vacaciones de verano. Mis primos y yo nos 
            agolpábamos frente al coche de mi abuelo, en el campo, porque conectaba un mini televisor a la batería para que pudiéramos seguir las aventuras de nuestro comando favorito. 
            Eso sí, en blanco y negro. Es lo que tenía veranear en ese terreno salvaje al que no había llegado la luz eléctrica. Aunque eso no impidió que El equipo A continuara 
            formando una parte importantísima de nuestras vidas infantiles. ¡Cuántas veces jugaríamos allí a ser ellos! Fingiríamos las habituales y divertidísimas peleas entre 
            Murdock y M. A. Simularíamos cómo había que dormir siempre al más fuerte de los compañeros para trasladarlo a algún lugar en avión o diríamos: “Me encanta que los planes 
            salgan bien”. En el fondo, esperábamos que una furgoneta negra con una franja roja en diagonal avanzara por el pedregoso camino que conducía a la parcela para invitarnos 
            a formar parte de una de sus misiones especiales.
        </p>

            <img src={img3} alt='Furgoneta del equipo A' style={{ display: 'block',margin: '30px auto', width: '80%'}}/>

       
            <h3>¿Y tú, seguías las aventuras de estos cuatro héroes?</h3>
        
</>
       
    )
}

export default ElequipoA